import { render, staticRenderFns } from "./TabCliente.vue?vue&type=template&id=0e4f37e4&"
import script from "./TabCliente.vue?vue&type=script&lang=js&"
export * from "./TabCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports